import * as ApiModels from '@typings/api-models';
import * as DocumentApiModels from '@/tsClient/servers/noodleDocuments/document-api-models';
import File from '@/components/DesignLibrary/File';
import CaretRight from '@components/Icons/CaretRight';
import classNames from 'classnames';

import s from './PacerDocumentRow.module.scss';

type Props = {
  onClick: () => void;
  selected: boolean;
  compiledDocument:
    & Pick<ApiModels.UserWorkflowDocument, 'id' | 'referenceId' | 'referenceType' | 'templateReferenceType'| 'title' | 'integrationSlug' | 'integrationFileName'>
    & {
      document: Pick<DocumentApiModels.Document, 'id' | 'mimeType' | 'fileName' | 'createdAt'> | null;
    }
};

const PacerDocumentRow: React.FC<Props> = ({ compiledDocument, onClick, selected }) => {
  const isEmpty = !compiledDocument.document;

  return (
    <button
      className={classNames(s['row-container'], selected && s.selected)}
      onClick={onClick}
    >
      {compiledDocument.document && !isEmpty
        && <File document={{
          createdAt: compiledDocument.document.createdAt,
          fileName: compiledDocument.integrationFileName || compiledDocument.document.fileName,
          id: compiledDocument.document.id,
          mimeType: compiledDocument.document.mimeType,
          uploadedAt: '',
          uploadedBy: { name: null },
        }} />}
      <CaretRight size={12} />
    </button>
  );
};

export default PacerDocumentRow;
